// Footer.js

function Footer() {
  return (
    <footer>
      <div className="footer-content">
        <p style={{ fontFamily: "'Source Sans 3', 'Segoe UI', sans-serif", fontSize: "14px" }}>
          &copy; 2026 Media &amp; Community Relations Centre | University of Peradeniya.
          All rights reserved.
        </p>
      </div>
    </footer>
  );
}

export default Footer;